/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { Tag, theme } from "@nordcloud/gnui";
import { getLabel } from "./utils";

const Wrap = styled.div`
  display: inline-block;
  position: relative;
`;

type Props = {
  name: string;
  value: string | string[] | boolean;
  onRemoveKey: () => void;
};

export function ExpandableTag({ name, value, onRemoveKey }: Props) {
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  return (
    <Wrap ref={wrapperRef}>
      <Tag
        showClose
        text={getLabel(name, value)}
        onClick={onRemoveKey}
        css={{
          margin: theme.spacing.spacing02,
          marginLeft: 0,
        }}
      />
    </Wrap>
  );
}
